/*eslint-disable*/
import Flickity from 'flickity'
export default imageSlider => {
  let pdpSliderFlkty = null;
  if (imageSlider) {
    const leftArrow = $('.js-img-slider-left')
    const rightArrow = $('.js-img-slider-right')
    pdpSliderFlkty = $(imageSlider).find('.product-photo-thumb').length > 5 || window.matchMedia("(max-width:768px)").matches
      ? new Flickity(imageSlider, {
        wrapAround: true,
        cellAlign: 'center',
        contain: true,
        prevNextButtons: false,
        imagesLoaded: true,
        pageDots: true,
        selectedAttraction: 0.1,
        friction: 0.5
      })
      : null
    pdpSliderFlkty && pdpSliderFlkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
    pdpSliderFlkty && pdpSliderFlkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })

    $(document).ready(() => {
      let featuredImageId = $('#productPhotoImg').data('image-id')
      let featuredImageThumb = $(`.product-photo-thumb img#${featuredImageId}`)
      $('.selected-thumb').removeClass('selected-thumb')
      $(featuredImageThumb).closest('span').addClass('selected-thumb')
      if (pdpSliderFlkty) {
        pdpSliderFlkty.select($(featuredImageThumb).closest('span').data('index') - 1)
        pdpSliderFlkty.resize()
        $(window).on('resize', () => pdpSliderFlkty && pdpSliderFlkty.resize())
        setTimeout(() => pdpSliderFlkty && pdpSliderFlkty.resize(), 1500)
      }

    })


    $('.product-photo-thumbs li').on('click', event => pdpSliderFlkty && pdpSliderFlkty.select($(event.target).data('index') - 1))
    $("body").on("keydown", e => {
      let code = e.keyCode;
      let $currentSelected = $('.selected-thumb')
      
      if (code === 37) {
        code && $('.selected-thumb').removeClass('selected-thumb')
        let $prevImageContainer = $currentSelected.closest('li').prev().attr('id')
          ? $currentSelected.closest('li').prev().find('.image-thumb')
          : $('.product-photo-thumbs .product-photo-thumb').last().find('.image-thumb')
        $prevImageContainer.addClass('selected-thumb')
        pdpSliderFlkty && pdpSliderFlkty.select($prevImageContainer.data('index') - 1)
      }

      if (code === 39) {
        code && $('.selected-thumb').removeClass('selected-thumb')
        let $nextImageContainer = $currentSelected.closest('li').next().attr('id')
          ? $currentSelected.closest('li').next().find('.image-thumb')
          : $('.product-photo-thumbs .product-photo-thumb').first().find('.image-thumb')
        $nextImageContainer.addClass('selected-thumb')
        pdpSliderFlkty && pdpSliderFlkty.select($nextImageContainer.data('index') - 1)
      }
    });

    $(leftArrow).click(() => {
      let $currentSelected = $('.selected-thumb')
      $('.selected-thumb').removeClass('selected-thumb')
      let $prevImageContainer = $currentSelected.closest('li').prev().attr('id')
        ? $currentSelected.closest('li').prev().find('.image-thumb')
        : $('.product-photo-thumbs li.product-photo-thumb').last().find('.image-thumb')
      $prevImageContainer.addClass('selected-thumb')
      pdpSliderFlkty && pdpSliderFlkty.previous()
    })

    $(rightArrow).click(() => {
      let $currentSelected = $('.selected-thumb')
      $('.selected-thumb').removeClass('selected-thumb')
      let $nextImageContainer = $currentSelected.closest('li').next().attr('id')
        ? $currentSelected.closest('li').next().find('.image-thumb')
        : $('.product-photo-thumbs li.product-photo-thumb').first().find('.image-thumb')
      $nextImageContainer.addClass('selected-thumb')
      pdpSliderFlkty && pdpSliderFlkty.next()
    })

    $('.swatch-group .swatch-element').each((_, swatch) => {
      $(swatch).data('image-id') && $(swatch).on('click', (el) => {
        if (!$(swatch).hasClass('no-linen') || $(swatch).closest('.variants').find('.selector-wrapper select[data-variant-option="Material"]').val() !== 'Linen') {
          let imageId = $(el.currentTarget).attr('data-image-id')
          let $variantThumb = $('.product-photo-thumb').find(`[data-image-id="${imageId}"]`)
          $('#productPhotoImg').attr({ 'data-index': $variantThumb.data('index'), 'data-image-id': $variantThumb.data('image-id') })
          $('.selected-thumb').removeClass('selected-thumb')
          $variantThumb.addClass('selected-thumb')
          pdpSliderFlkty && pdpSliderFlkty.select($variantThumb.data('index') - 1)
        }
      })
    })

    $(window).on('load resize', () => {
      if (window.matchMedia("(max-width:768px)").matches) {
        if (!pdpSliderFlkty)
          pdpSliderFlkty = new Flickity(imageSlider, {
            wrapAround: true,
            cellAlign: 'center',
            contain: true,
            prevNextButtons: false,
            imagesLoaded: true,
            pageDots: true
          })
        $('.product-photo-thumbs li.product-photo-thumb span').each((_, span) => {
          let imgSrc = $(span).find('img').data('img-src')
          $(span).css('background-image', `url(${imgSrc})`)
        })
      } else {
        if ($(imageSlider).find('.product-photo-thumb').length <= 5 && pdpSliderFlkty) {
          pdpSliderFlkty.destroy()
          pdpSliderFlkty = null;
          $('.product-photo-thumbs li.product-photo-thumb').each((_, thumb) => {
            $(thumb).css('left', '0')
          })
        }
        $('.product-photo-thumbs li.product-photo-thumb span').each((_, span) => {
          $(span).css('background-image', "none")
        })

      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/pdp-slider.js